import MainCard from 'components/MainCard';
import ContactForm from 'components/contact-form';
import { useEffect, useState } from 'react';
import { getContactById } from '../api';
import ContactDto from 'common/dto-types/contacts/contact-dto';
import { useParams } from 'react-router';

const ContactDetailsPage = () => {
    const { id } = useParams();
    const [contact, setContact] = useState<ContactDto>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getContactById(parseInt(id || ''))
            .then((data) => {
                if (data) setContact(data);
            })
            .finally(() => setLoading(false));
    }, [id]);

    return (
        <MainCard content={false} title="Contact Information" sx={{ width: '70%', marginX: 'auto' }}>
            {!loading && <ContactForm contact={contact} />}
        </MainCard>
    );
};

export default ContactDetailsPage;
